import { useEffect, useState } from 'react';

/**
 * Разделитель «телефон / компьютер». true — узкий экран (телефон).
 * По нему включается мобильная версия и прячутся тяжёлые экраны (Гант/Отчёты/Персонал).
 */
export function useIsMobile(breakpoint = 768): boolean {
  const query = `(max-width:${breakpoint - 1}px)`;
  const [mobile, setMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMobile(mq.matches);
    mq.addEventListener('change', onChange);
    onChange();
    return () => mq.removeEventListener('change', onChange);
  }, [query]);
  return mobile;
}
